import { Badge } from "@/components/ui/badge";
import { Sparkles, CircleDashed } from "lucide-react";
import { fmtDate } from "../studioApi";

// Indicator shown wherever teas are chosen for a catalogue: has the AI evaluation (scores) been done and accepted?
export const AiMark = ({ product, size = "xs", testid }) => {
  const s = product?.ai_scoring;
  const cls = size === "xs" ? "text-[10px] px-1.5 py-0" : "text-xs";
  if (s?.run_at) {
    return (
      <Badge variant="outline" className={`${cls} gap-1 bg-teal-50 text-teal-800 border-teal-300 whitespace-nowrap`} title={`AI evaluation accepted on ${fmtDate(s.run_at)}${s.band_label ? ` · band ${s.band_label}` : ""}${s.applied ? ` · ${s.applied} value(s) applied` : ""}`} data-testid={testid || `ai-mark-${product.id}`}>
        <Sparkles className="h-3 w-3" /> AI evaluated{size !== "xs" ? ` · ${fmtDate(s.run_at)}` : ""}
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className={`${cls} gap-1 bg-stone-50 text-stone-500 border-stone-300 whitespace-nowrap`} title="“Let AI score” has not been run and accepted for this tea" data-testid={testid || `ai-mark-${product?.id}`}>
      <CircleDashed className="h-3 w-3" /> Not AI evaluated
    </Badge>
  );
};
